import { Page500 } from '@/components/ErrorPages';
import styled from 'styled-components';

export const StyledPage500 = styled(Page500)`
  flex: 1 0 auto;
`;
